import React from "react";
import ReactDOM from "react-dom";
import MinesweeperApp from "./MinesweeperApp";

ReactDOM.render(<MinesweeperApp />, document.getElementById("root"));
